<template>
  <div class="content-container">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.content-container{
    flex: 1;
    overflow-y: auto;
    padding-top: 10px;
}
</style>
